var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer"},[_c('div',{staticClass:"container"},[_c('nav'),_vm._v(" "),_c('div',{staticClass:"copyright text-center"},[_vm._v("\n      © "+_vm._s(new Date().getFullYear())+"\n      "),_c('a',{attrs:{"href":"https://texasusit.org","target":"_blank"}},[_vm._v("Texas USIT")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2aff9edc","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Layout/ContentFooter.vue
// module id = null
// module chunks = 